import { get, set } from '../../../utils/tempStorage';
export const getHasBeenExposedToExperiment = (experimentKey, portalId) => {
  const localStorageKey = `growth-coaching:${experimentKey}-${portalId}`;
  const hasBeenExposed = get(localStorageKey) === 'true';
  return {
    hasBeenExposed
  };
};
export const setHasBeenExposedToExperiment = (experimentKey, portalId) => {
  const localStorageKey = `growth-coaching:${experimentKey}-${portalId}`;
  set(localStorageKey, 'true');
};